<template>
  <InputWithMarketSpecificInfo
    :label-default="labelDefault"
    :label-markets="labelMarkets"
    :market="market"
    :text-default="textDefault"
    :text-markets="textMarkets"
    :title-default="titleDefault"
    :title-markets="titleMarkets"
  >
    <slot></slot>
  </InputWithMarketSpecificInfo>
</template>

<script setup>
import { defineProps } from 'vue'
import InputWithMarketSpecificInfo from '@/components/inputs/InputWithMarketSpecificInfo.vue'
import { useTranslation } from '@/composables/translation'

const { $t } = useTranslation()

const props = defineProps({
  market: {
    type: String,
    default: null,
  },
})

const labelDefault = $t('Company registration number')

const labelMarkets = {
  AU: $t('ABN'),
  CA: $t('Business number'),
  DE: $t('Steuernummer/UstID-nr'),
  FR: $t('SIREN / SIRET'),
  US: $t('FEIN'),
  SG: $t('UEN (company registration number)'),
}

const textDefault = $t(
  'A company registration number is the number used to identify a company in the country where it operates.  It is often issued by business or tax-related authorities, and is unique to a company or legal entity.',
)

const textMarkets = {
  AU: $t(
    'The Australian Business Number (ABN) is a unique 11 digit number that identifies your business to the government and community.',
  ),
  CA: $t(
    'A business number is a unique, 9-digit number – the standard identifier for businesses in Canada and is issued by the Canada Revenue Agency. It is unique to a business or legal entity.',
  ),
  IE: $t(
    'A company registration number is a unique code, that identifies companies in Ireland. It is issued by Companies House and is unique to a company or legal entity.',
  ),
  SG: $t(
    'The Unique Entity Number (UEN) is a 9 or 10 digit identification number that is issued by the government in Singapore to all entities that operate within the country.',
  ),
  UK: $t(
    'A company registration number is a unique, 8-character code that identifies companies in the UK.  It is issued by Companies House, and is unique to a company or legal entity.',
  ),
  US: $t(
    'A Federal Tax Identification Number (FEIN) is also known as an Employer Identification Number (EIN), and is used to identify a business entity. Generally, businesses need an EIN and it can be obtained for free from the Internal Revenue Service.',
  ),
}

const titleDefault = $t(`What is this?`)

const titleMarkets = {
  AU: $t(`What's an ABN?`),
  CA: $t(`What's a business number?`),
  SG: $t(`What's a UEN?`),
  US: $t(`What's a FEIN?`),
}
</script>
